var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "submitFile",
      "centered": true,
      "title": "Do you want to submit the claim?",
      "hide-footer": true,
      "size": "md",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.resetForm
    }
  }, [_c('div', [_c('label', {
    staticClass: "plan_name_label"
  }, [_vm._v("Plan Name: ")]), _c('p', {
    staticClass: "prudential_plan_name"
  }, [_vm._v(_vm._s(_vm.claimData.plan_name))])]), _vm.claimData.is_LifeOr7kEnabled ? _c('div', {
    staticClass: "date-picker-wrap mb-3"
  }, [_c('label', {
    staticClass: "d-block",
    attrs: {
      "for": "claim-date"
    }
  }, [_vm._v("Death Date "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Enter Death Date",
      "disabled-date": _vm.disableDates
    },
    model: {
      value: _vm.death_date,
      callback: function ($$v) {
        _vm.death_date = $$v;
      },
      expression: "death_date"
    }
  }), _vm.formTouched && !_vm.$v.death_date.required ? _c('span', {
    staticClass: "error_message d-block"
  }, [_vm._v("Death date is required")]) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "file-content-wrap"
  }, [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v(" The file"), _vm.files.length > 1 ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(" you want to upload: ")]), _c('div', {
    staticClass: "d-flex flex-wrap"
  }, _vm._l(_vm.files, function (file) {
    return _c('div', {
      key: file.id,
      staticClass: "mb-2 pr-0 mr-2"
    }, [_c('div', {
      staticClass: "file-name-list"
    }, [_c('a', {
      staticClass: "clr-active",
      attrs: {
        "href": file.filepath,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(file.filename))])])]);
  }), 0)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "cancel-btn mr-3"
  }, [_c('button', {
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Cancel")])]), _c('div', {
    staticClass: "submit-btn"
  }, [_c('button', {
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }